import styles from './AvailableBrowser.module.scss'
import { ReactComponent as BrowserIcon } from './browser.svg'

const AvailableBrowser = () => (
  <div className={styles.wrapper}>
    <div className={styles.container}>
      <div className={styles.desc}>
        <BrowserIcon />
        <h1>Direcful Dashboard works on Google Chrome and Microsoft Edge</h1>
        <p>Please visit this page using Chrome or Edge browser</p>
      </div>
    </div>
  </div>
)

export default AvailableBrowser
